import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-widget-data',
  templateUrl: './widget-data.component.html',
  styleUrls: ['./widget-data.component.scss'],
  standalone: false
})
export class WidgetDataComponent {
  @Input() title: string = '';

  @Input() data: any;
  @Input() extraData: any;
  @Input() statusData: 'danger' | 'success' | '' = '';
}
